import { render, staticRenderFns } from "./HuchaListado.vue?vue&type=template&id=16cb6230&scoped=true"
import script from "./HuchaListado.vue?vue&type=script&lang=js"
export * from "./HuchaListado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cb6230",
  null
  
)

export default component.exports